module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4yUUm"))).then(() => parcelRequire('eyn6E'));